jQuery(document).ready(function ($) {
  function experience_carousel() {
    jQuery(".booking-experience-list").slick({
      arrows: true,
      dots: true,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 9999,
          settings: {
            arrows: true,
          },
        },
        {
          breakpoint: 992,
          settings: {
            arrows: false,
          },
        },
      ],
    });
  }
  function scroll_to_form() {
    jQuery("a[href='#booking-form']").each((i, button) => {
      jQuery(button).on("click", function () {
        jQuery("html, body").animate(
          {
            scrollTop: jQuery("#booking-form").offset().top - 200,
          },
          1000
        );
      });
    });
  }

  experience_carousel();
  scroll_to_form();
});
